import React, { CSSProperties } from 'react';
import { useRecoilValue } from 'recoil';
import { ProductHandle } from '../enums/ProductHandle.enum';
import { SelectionType } from '../enums/SelectionType.enum';
import { useProductSelection } from '../hooks/useProductSelection';
import { isMobileState } from '../recoil/selectors';
import { GiftCardControlsDesktop } from './GiftCardControlsDesktop';
import { GiftCardControlsMobile } from './GiftCardControlsMobile';
import { ProductControlsDesktop } from './ProductControlsDesktop';
import { ProductControlsMobile } from './ProductControlsMobile';

export interface ProductControlProps {
  selectionType: SelectionType;
  selectionKey: string;
  style?: CSSProperties;
  simplified?: boolean;
}

export const ProductControls: React.FC<ProductControlProps> = (props) => {
  const isMobile = useRecoilValue(isMobileState);
  const { product } = useProductSelection(props.selectionType, props.selectionKey);

  if (product.handle === ProductHandle.EGiftCard) {
    return isMobile ? <GiftCardControlsMobile {...props} /> : <GiftCardControlsDesktop {...props} />;
  }

  return isMobile ? <ProductControlsMobile {...props} /> : <ProductControlsDesktop {...props} />;
};

export default ProductControls;
